import { Button, Tooltip } from '@mui/material'
import images from 'assets/images'
import React from 'react'
import { URL_APP } from 'helpers/config'
import linkedin from 'helpers/integrations/linkedin'
import { useParams, useSearchParams } from 'react-router-dom'
import TagManager from 'react-gtm-module'

const SignUpWithLinkedInButton: React.FC = () => {
  const { productId } = useParams()
  const [searchParams] = useSearchParams()

  const sendGTMSignup = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'signupFormUpdate',
        signupStep: 'signup-linkedin',
      },
    })
  }

  const onClick = () => {
    sendGTMSignup()
    linkedin.connect({
      redirectUrl: URL_APP,
      action: 'SIGNUP',
      productId,
      overrideDefaultSignupAction: searchParams.get('overrideDefaultSignupAction') ?? undefined,
    })
  }

  return (
    <Tooltip title="Sign up with LinkedIn">
      <Button
        onClick={onClick}
        variant="outlined"
        sx={{ '&, &:hover': { borderColor: '#1445FE' }, borderRadius: '99px', width: '40px', height: '40px', p: 0, minWidth: 0 }}
      >
        <img src={images.LINKEDIN_SQUARE_LOGO} alt="LinkedIn logo" style={{ width: '20px', height: '20px' }} />
      </Button>
    </Tooltip>
  )
}

export default SignUpWithLinkedInButton
